import React, {useId, useState} from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    SimpleGrid,
    Text,
    Image,
    Button,
    // Divider,
    Flex,
    useMultiStyleConfig,
    useMediaQuery,
} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'
import {ChevronDownIcon} from '@chakra-ui/icons'
import {FormattedMessage} from 'react-intl'
import {getDamBaseUrl} from '../../custom-hooks/use-dam-image'

const WhatsInTheBox = ({items, variant = 'default'}) => {
    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(767)})`)
    const [isTablet] = useMediaQuery(`(max-width: ${remCalc(1023)})`)
    const maxVisibleItems = isMobile ? 6 : isTablet ? 8 : 14
    const [showAll, setShowAll] = useState(false)
    const visibleItems = showAll ? items : items.slice(0, maxVisibleItems)
    const hasMore = items.length > maxVisibleItems
    const listId = useId()

    // Use styles from RecommendedProducts theme
    const styles = useMultiStyleConfig('WhatsInTheBox', {variant})
    const baseUrl = getDamBaseUrl()

    return (
        <Flex {...styles.backgroundContainer}>
            <Flex {...styles.outerContainer} data-testid="whats-in-the-box">
                <Text as="h2" {...styles.headerLabel}>
                    <FormattedMessage
                        defaultMessage="What's in the box"
                        id="whats_in_the_box.heading"
                    />
                </Text>
                <SimpleGrid as="ul" id={listId} role="list" {...styles.elementsGrid}>
                    {visibleItems.map((item, idx) => (
                        <Box as="li" key={idx} {...styles.elementContainer}>
                            <Image
                                src={`${baseUrl}/${item?.imageLink}`}
                                alt={item?.title || `Box item ${idx + 1}`}
                                {...styles.elementImage}
                            />
                            <Text sx={styles.itemLabel}>{item.title}</Text>
                        </Box>
                    ))}
                </SimpleGrid>
                {hasMore && !showAll && (
                    <Box textAlign="center" mt={6}>
                        <Button
                            sx={styles.showAllButton}
                            aria-expanded={showAll}
                            aria-controls={listId}
                            onClick={() => setShowAll(true)}
                        >
                            <FormattedMessage
                                defaultMessage="Show all"
                                id="whats_in_the_box.button.show_all"
                            />
                            <ChevronDownIcon aria-hidden="true" w={remCalc(24)} h={remCalc(24)} />
                        </Button>
                    </Box>
                )}

                {/* Commented out since I'm pretty sure this is not intended to be removed but a ticket asked to remove the divider so...*/}

                {/* <Box width="100%" px={{base: 4, md: 6}}>
                    <Divider mt={8} />
                </Box> */}
            </Flex>
        </Flex>
    )
}

WhatsInTheBox.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            imageLink: PropTypes.string,
            title: PropTypes.string,
        }),
    ).isRequired,
    variant: PropTypes.string,
}

export default WhatsInTheBox
